import { primitives } from './Primitives';

export const newColors: { [key: string]: { [key: string]: string } } = {
  'text.default': {
    default: primitives.greyscale['900-solid'],
  },
  'text.muted': {
    default: primitives.greyscale['800-solid'],
  },
  'text.hint': {
    default: primitives.greyscale['700'],
  },
  'text.onAccent': {
    default: primitives.white['1000'],
  },
  'text.selected': {
    default: '#7032AE',
  },
  'text.disabled': {
    default: primitives.greyscale['700'],
  },
  'text.onAccent.disabled': {
    default: primitives.white['600'],
  },
  'text.success': {
    default: '#507068',
  },
  'text.warning': {
    default: '#C45000',
  },
  'text.critical': {
    default: '#C30000',
  },
  'text.info': {
    default: '#544167',
  },
  'text.action': {
    default: '#7032AE',
  },
  'text.compliant': {
    default: '#507068',
  },
  'text.notCompliant': {
    default: '#C30000',
  },
  'border.default': {
    default: primitives.greyscale['500'],
  },
  'border.hover': {
    default: primitives.greyscale['600'],
  },
  'border.selected.accent': {
    default: '#7032AE',
  },
  'border.critical.accent': {
    default: '#C30000',
  },
  'border.decorative': {
    default: primitives.greyscale['400'],
  },
  'border.onAccent': {
    default: primitives.white['300'],
  },
  'border.disabled': {
    default: primitives.greyscale['400'],
  },
  'border.drop': {
    default: '#B79AD2CC',
  },
  'border.success': {
    default: '#64C7B233',
  },
  'border.warning': {
    default: '#FFB03533',
  },
  'border.critical': {
    default: '#F64C4C2B',
  },
  'border.unknown': {
    default: primitives.greyscale['200'],
  },
  'border.info': {
    default: '#B79AD22E',
  },
  'border.divider': {
    default: primitives.greyscale['400'],
  },
  'border.info.accent': {
    default: '#7032AEBF',
  },
  'border.illustration': {
    default: primitives.greyscale['500-solid'],
  },
  'bg.default': {
    default: primitives.white['1000'],
  },
  'bg.muted': {
    default: primitives.greyscale['100-solid'],
  },
  'bg.decorative': {
    // decorative bg
    default: primitives.gradient['01'],
  },
  'bg.defaultToDecorative': {
    // transition from default bg to decorative bg
    default: primitives.gradient.defaultTo01,
  },
  'bg.defaultToTransparent': {
    // transition from default bg to transparent bg
    default: primitives.gradient.defaultToTransparent,
  },
  'bg.interactive': {
    default: '#0F0F2E0F',
  },
  'bg.interactive.accent': {
    default: '#0F0F2E14',
  },
  'bg.hover': {
    default: '#0F0F2E0F',
  },
  'bg.pressed': {
    default: '#0F0F2E14',
  },
  'bg.disabled': {
    default: '#0F0F2E0D',
  },
  'bg.disabled.accent': {
    default: '#0F0F2E24',
  },
  'bg.sidebar': {
    default: '#F0F0F0',
  },
  'bg.accent': {
    default: '#544167',
  },
  'bg.backdrop': {
    default: primitives.greyscale['700'],
  },
  'bg.drop': {
    default: '#B79AD273',
  },
  'bg.progress': {
    default: primitives.greyscale['800'],
  },
  'bg.onAccent.hover': {
    default: primitives.white['200'],
  },
  'bg.onAccent.hover.sidebar': {
    default: '#0F0F2E0F',
  },
  'bg.onAccent.pressed': {
    default: primitives.white['500'],
  },
  'bg.transparent': {
    default: '#0F0F2E1F',
  },
  'bg.selected': {
    default: '#B79AD22E',
  },
  'bg.selected.hover': {
    default: '#B79AD247',
  },
  'bg.selected.pressed': {
    default: '#B79AD273',
  },
  'bg.selected.accent': {
    default: '#7032AE',
  },
  'bg.selected.accent.hover': {
    default: '#572786',
  },
  'bg.selected.muted': {
    default: primitives.greyscale['100'],
  },
  'bg.onAccent.selected': {
    default: '#0F0F2E0F',
  },
  'bg.action.accent': {
    default: '#614979',
  },
  'bg.action.accent.hover': {
    default: '#4D3B5E',
  },
  'bg.action.accent.pressed': {
    default: '#34293D',
  },
  'bg.elevated.interactive': {
    default: primitives.white['1000'],
  },
  'bg.elevated.interactive.hover': {
    default: primitives.white['1000'],
  },
  'bg.elevated.overlay': {
    default: primitives.white['1000'],
  },
  'bg.success': {
    default: '#64C7B21F',
  },
  'bg.success.hover': {
    default: '#64C7B233',
  },
  'bg.success.pressed': {
    default: '#64C7B247',
  },
  'bg.success.accent': {
    default: '#64C7B2',
  },
  'bg.warning': {
    default: '#FFB03526',
  },
  'bg.warning.hover': {
    default: '#FFB03533',
  },
  'bg.warning.pressed': {
    default: '#FFB03540',
  },
  'bg.warning.accent': {
    default: '#FFB035',
  },
  'bg.critical': {
    default: '#F64C4C1C',
  },
  'bg.critical.hover': {
    default: '#F64C4C2B',
  },
  'bg.critical.pressed': {
    default: '#F64C4C40',
  },
  'bg.critical.accent': {
    default: '#F64C4C',
  },
  'bg.unknown': {
    default: '#0F0F2E14',
  },
  'bg.unknown.hover': {
    default: '#0F0F2E1A',
  },
  'bg.unknown.pressed': {
    default: '#0F0F2E24',
  },
  'bg.unknown.accent': {
    default: primitives.greyscale['600'],
  },
  'bg.unknown.muted': {
    default: '#0F0F2E0F',
  },
  'bg.info': {
    default: '#B79AD22E',
  },
  'bg.info.hover': {
    default: '#B79AD247',
  },
  'bg.info.pressed': {
    default: '#B79AD273',
  },
  'bg.info.accent': {
    default: '#B79AD2B3',
  },
  'bg.info.muted': {
    default: '#B79AD22E',
  },
  'bg.compliant': {
    default: '#64C7B21F',
  },
  'bg.compliant.hover': {
    default: '#64C7B233',
  },
  'bg.compliant.pressed': {
    default: '#64C7B247',
  },
  'bg.compliant.accent': {
    default: '#64C7B2',
  },
  'bg.notCompliant': {
    default: '#F64C4C1C',
  },
  'bg.notCompliant.hover': {
    default: '#F64C4C2B',
  },
  'bg.notCompliant.pressed': {
    default: '#F64C4C40',
  },
  'bg.notCompliant.accent': {
    default: '#F64C4C',
  },
  'bg.notEligible.accent': {
    default: primitives.greyscale['800'],
  },
  'bg.notEligibleAligned.accent': {
    default: primitives.greyscale['600'],
  },
  'bg.promo': {
    default: '#614979',
  },
  'bg.decor.01': {
    default: '#028387',
  },
  'bg.decor.02': {
    default: '#3A8DB5',
  },
  'bg.decor.03': {
    default: '#147300',
  },
  'bg.decor.04': {
    default: '#E54200',
  },
  'bg.decor.05': {
    default: '#792259',
  },
  'bg.decor.06': {
    default: '#0E0E2F',
  },
  'bg.decor.07': {
    default: '#C11855',
  },
  'bg.decor.08': {
    default: '#0171DA',
  },
  'bg.decor.01-muted': {
    default: '#0283870F',
  },
  'bg.decor.02-muted': {
    default: '#3A8DB50F',
  },
  'bg.decor.03-muted': {
    default: '#1473000F',
  },
  'bg.decor.04-muted': {
    default: '#E542000F',
  },
  'bg.decor.05-muted': {
    default: '#7922590F',
  },
  'bg.decor.06-muted': {
    default: '#0E0E2F0F',
  },
  'bg.decor.07-muted': {
    default: '#C118550F',
  },
  'bg.decor.08-muted': {
    default: '#0171DA0F',
  },
  'misc.shadow.default': {
    default: primitives.greyscale['300'],
  },
  'misc.shadow.accent': {
    default: primitives.greyscale['400'],
  },
  'misc.shadow.border': {
    default: primitives.greyscale['400'],
  },
  'misc.shadow.hover': {
    default: primitives.greyscale['500'],
  },
  'misc.focus': {
    default: '#008EA6',
  },
  'text.sidebar': {
    default: primitives.greyscale['900-solid'],
  },
};
